import SearchBar from '../../atoms/search-bar/SearchBar';
import './HomeBannerSearch.scss';


interface Props {
    bannerData: any
}

const HomeBannerSearch = ({ bannerData }: Props) => {

    return (
        <div className="m-banner-search" style={{ backgroundImage: `url(${bannerData.bgImage})` }}>
            <div className="m-banner-search-container cda-main-container">
                <h1>{bannerData.title}</h1>
                <SearchBar />
            </div>
        </div>
    )
}

export default HomeBannerSearch